/*
	Core functionality for tracking and testing
 */

const { __, _x, _n, sprintf } = wp.i18n;

export function YLWPUXsetCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export function YLWPUXgetCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
export function YLWPUXsendWPEvent(block_id, event_name, event_value, event_type = 'ywp_ux_tracker') {
	let formData = new FormData();

	let eventData = {
		"id": block_id,
		"name": event_name,
		"value": event_value,
		"type": event_type
	}

	let jsonEventData = JSON.stringify(eventData);

	formData.append( 'action', 'register_event' );
	formData.append( 'post_id', ajax_object.post_id,);
	formData.append( 'event_data', jsonEventData);

	fetch( ajax_object.ajaxurl, {
		method: 'POST',
		body: formData,
	} ) // wrapped
		.then( res => res.text() )
		.then( data => console.log( data ) )
		.catch( err => console.log( err ) );

// put the markup created by server and put it inside somewhere in the frontend

}

export function YLWPUXsendGAEvent(event_name, event_value, event_type = 'ywp_ux_tracker') {
	if (window.gtag) {
		gtag("event", event_type, {
			ux_name: event_name,
			ux_value: event_value,
			page_location: window.location.href
		});
	} else {


		console.log('No GTAG present – Event name: '+event_name + ', Event value: ' + event_value);
	}
}

function YLWPUXsetupTrackerlinks() {
	let trackerLinks = document.querySelectorAll('[data-ywpuxtrack="true"]');

	for(const trackerLink of trackerLinks) {
		trackerLink.addEventListener('click', ( event ) => {
			if("true" !== trackerLink.getAttribute('data-uxclicked')) {
				event.preventDefault();

				let eventName = trackerLink.getAttribute('data-ywpuxtrackname');
				let eventValue = trackerLink.getAttribute('data-ywpuxtrackvalue');
				let href = trackerLink.getAttribute('href');

				YLWPUXsendGAEvent(eventName, eventValue);
				trackerLink.setAttribute('data-uxclicked', "true");
				window.location.href = href;

			} else {

			}

		})
	}
}

function YLWPUXsetupTestVersion() {
	let testVersion = YLWPUXgetCookie('ywptentrset');

	if (('' === testVersion) || (testVersion !== 'a' && testVersion !== 'b')) {
		testVersion = Math.random() < 0.5 ? 'a' : 'b';
		YLWPUXsetCookie('ywptentrset', testVersion, 7);
	}

	return testVersion;
}
function YLWPUXsetupABElements(testVersion) {

	let abElements = document.querySelectorAll('[data-yuxab="true"]');

	for(const abElement of abElements) {
		let testDataJson = abElement.getAttribute('data-yuxjson');
		let testData = JSON.parse(testDataJson);

		if (testData.blockversion.toLowerCase() !== testVersion.toLowerCase()) {
			abElement.remove();
		} else {
			abElement.style.removeProperty('visibility')
		}
	}
}

document.addEventListener("DOMContentLoaded", function(event) {
	let testVersion = YLWPUXsetupTestVersion();
	YLWPUXsetupTrackerlinks();
	YLWPUXsetupABElements(testVersion);
});
